import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const useStyles = makeStyles(
  theme => ({
    noFilterBox: {
      ...theme.flex.center,
      width: '100%',
      height: 'calc(100vh - 224px)',
      minHeight: 400,
      marginTop: '16px',
      backgroundColor: theme.colors.gray1,
    },
    noFilterChild: {
      textAlign: 'center',
      '& svg': { display: 'block', marginLeft: 'auto', marginRight: 'auto' },
    },

    decTop: { fontSize: '14px', lineHeight: '24px', marginTop: '16px' },
  }),
  { name: 'emptyPage' },
);

const BlankPage = props => {
  const { svg, descKey } = props;
  const { t } = useTranslation();
  const descInfo = t(descKey);
  const classes = useStyles();

  return (
    <div className={classes.noFilterBox}>
      <div className={classes.noFilterChild}>
        <div>{svg}</div>

        {descInfo && <div className={`${classes.decTop} `}> {descInfo}</div>}
      </div>
    </div>
  );
};

BlankPage.propTypes = {
  svg: PropTypes.element.isRequired,
  descKey: PropTypes.string,
};

export default BlankPage;
